import React from 'react';
import './MetallicLoadingEffect.css';

const WebsiteLoadingSkeleton = () => {
    return (
        <div className="loading-skeleton">
            {/* Header Skeleton */}
            <div className="header-skeleton">
                <div className="metallic-loading premium logo-skeleton"></div>
                <div className="nav-skeleton">
                    <div className="metallic-loading nav-item-skeleton"></div>
                    <div className="metallic-loading nav-item-skeleton"></div>
                    <div className="metallic-loading nav-item-skeleton"></div>
                    <div className="metallic-loading nav-item-skeleton"></div>
                </div>
                <div className="metallic-loading button-loading"></div>
            </div>

            {/* Hero Section Skeleton */}
            <div className="metallic-loading premium hero-skeleton"></div>

            {/* Products Grid Skeleton */}
            <div className="products-grid-skeleton">
                {[...Array(8)].map((_, index) => (
                    <div key={index} className="metallic-loading premium product-skeleton"></div>
                ))}
            </div>

            {/* Additional Content Sections */}
            <div style={{ marginBottom: '30px' }}>
                <div className="metallic-loading text-loading" style={{ width: '200px', height: '30px', marginBottom: '20px' }}></div>
                <div className="metallic-loading text-loading" style={{ width: '100%', marginBottom: '10px' }}></div>
                <div className="metallic-loading text-loading" style={{ width: '80%', marginBottom: '10px' }}></div>
                <div className="metallic-loading text-loading" style={{ width: '60%', marginBottom: '20px' }}></div>
                
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <div className="metallic-loading button-loading"></div>
                    <div className="metallic-loading button-loading"></div>
                    <div className="metallic-loading button-loading"></div>
                </div>
            </div>

            {/* Footer Skeleton */}
            <div className="metallic-loading premium footer-skeleton"></div>

            {/* Loading Progress Indicator */}
            <div style={{
                position: 'fixed',
                bottom: '20px',
                right: '20px',
                background: 'rgba(0,0,0,0.8)',
                color: 'white',
                padding: '10px 20px',
                borderRadius: '25px',
                fontSize: '14px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
            }}>
                <div style={{
                    width: '20px',
                    height: '20px',
                    border: '2px solid rgba(255,255,255,0.3)',
                    borderTop: '2px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
                Loading Herramientas Tayrun...
            </div>

            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default WebsiteLoadingSkeleton;

